package com.xtream.data_kmp.dto


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
{
"success": true,
"playlists": [
{
"id": "uuid-1",
"name": "Arabic IPTV",
"url": "http://example.com/arabic.m3u",
"is_protected": false,
"is_active": true,
"created_at": "2026-06-19T10:00:00Z"
},
{
"id": "uuid-2",
"name": "Sports Pack",
"url": "http://example.com/sports.m3u",
"is_protected": true,
"is_active": true,
"created_at": "2026-06-18T08:00:00Z"
}
],
"total": 2,
"default_playlist_url": "http://fallback.com/default.m3u"
}
*/

@Serializable
data class PlaylistsResponse(
    @SerialName("success")
    val success: Boolean,
    @SerialName("playlists")
    val playlists: List<PlayerPlaylistItem>,
    @SerialName("total")
    val total: Int,
    @SerialName("default_playlist_url")
    val defaultPlaylistUrl: String?
)

@Serializable
data class PlayerPlaylistItem(
    @SerialName("id")
    val id: String?,
    @SerialName("name")
    val name: String?,
    @SerialName("url")
    val url: String?,
    @SerialName("is_protected")
    val isProtected: Boolean?,
    @SerialName("is_active")
    val isActive: Boolean?,
    @SerialName("created_at")
    val createdAt: String?
)




//register
@Serializable
data class RegisterDeviceResponse(
    @SerialName("success")
    val success: Boolean,
    @SerialName("device_id")
    val deviceId: String?,
    @SerialName("device_key")
    val deviceKey: String?,
    @SerialName("is_new")
    val isNew: Boolean?
)







///status
@Serializable
data class DeviceStatusResponse(
    @SerialName("success")
    val success: Boolean,
    @SerialName("is_activated")
    val isActivated: Boolean,
    @SerialName("activation")
    val activation: ActivationInfo?
)

@Serializable
data class ActivationInfo(
    @SerialName("status")
    val status: String?,
    @SerialName("expires_at")
    val expiresAt: String?,
    @SerialName("package_name")
    val packageName: String?
)